import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./index.scss";
import BsModal from "react-bootstrap/Modal";
import { Image, Row, Col, Button } from "react-bootstrap";

const Modal = (props) => {
  const { setShowModal, imgSrc, isPdf, custom_value, isOtherFile, downloadUrl,isSpreadSheet} = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [show, setShow] = useState(false);
  const [modalSize, setModalSize] = useState("");

  useEffect(() => {
    if (isPdf) {
      setModalSize("xl");
    }
  }, []);
  useEffect(() => {
    setShow(true);
  }, []);

  const handleClose = (e) => {
    setShowModal(false);
  };

  const downloadOtherFile = (e) => {
    e.preventDefault()
    window.location.href = downloadUrl;
  };
  const search = window.location.href;
  const [zooming,setZooming] = useState(false)
  const [dragging, setDragging] = useState(true);
  const [zoomValue, setZoomValue] = useState(0);
  const [prevZoom, setPrevZoom] = useState(0);
  const [rotateValue, setRotateValue] = useState(90)


  const handleZoomIn = () =>{
    const newZoomValue = Math.min(zoomValue + 0.5, 5);
    setPrevZoom(zoomValue)
    setZoomValue(newZoomValue)
    zoom(newZoomValue,newZoomValue > prevZoom)
  }

  const handleZoom = (value) =>{
    const newZoomValue = Math.min(Math.max(value, 0), 5);
    setPrevZoom(zoomValue)
    setZoomValue(newZoomValue)
    if(newZoomValue === 0) setPrevZoom(0)
    zoom(newZoomValue,newZoomValue > prevZoom)
  }

  const zoom = (zoomValue, zooming) =>{
    const image = document.getElementById('modalImage');
    const imageWidth = image.clientWidth
    image.classList.toggle('w-100', zoomValue <= 0)
    image.style.width = zooming ? imageWidth + (zoomValue * 25) + 'px' : imageWidth - (zoomValue * 25) + 'px'
    image.classList.toggle('cursor-grab', zoomValue > 0)
    setZooming(zoomValue > 0 ? true : false)
    if(zoomValue === 0){
      image.style.top = 0;
      image.style.left = 0;
    }
  }

const dragImage = (e) => {
  const image = document.getElementById('modalImage');
  setDragging(!dragging);
  image.classList.toggle('cursor-move',dragging && zooming)
  if (dragging && zooming) {
    let initialCoords = {
      x: e.clientX - image.offsetLeft,
      y: e.clientY - image.offsetTop,
    };

    const handleMouseMove = (e) => {
      image.style.top = e.clientY - initialCoords.y + 'px';
      image.style.left = e.clientX - initialCoords.x + 'px';
    };

    const handleMouseUp = () => {
      setDragging(false);
      image.removeEventListener('mousemove', handleMouseMove);
      image.removeEventListener('mouseup', handleMouseUp);
    };

    image.addEventListener('mousemove', handleMouseMove);
    image.addEventListener('mouseup', handleMouseUp);
  }
};

const rotateImage = () =>{
  
  const image = document.getElementById('modalImage')
  image.style.transform = `rotate(${rotateValue}deg)`
  setRotateValue(rotateValue + 90)
  if(rotateValue === 360) setRotateValue(90)
}



return (
    <>
        {isPdf === undefined ? ( //Rendering from comments section
            <BsModal
                show={show}
                onHide={handleClose}
                scrollable
                size={modalSize}
                centered
            >
                <BsModal.Header
                    closeButton
                    className="pb-0 justify-content-between"
                >
                    <BsModal.Title>Preview</BsModal.Title>
                </BsModal.Header>
                <BsModal.Body className="theme-scrollbar">
                    <Row className="align-items-center justify-content-center">
                        <Col lg={12}>
                            <Image alt={`failed to load`} src={imgSrc} fluid />
                        </Col>
                    </Row>
                </BsModal.Body>
            </BsModal>
        ) : isPdf ? ( //If it is pdf
            <>
                <BsModal
                    show={show}
                    onHide={handleClose}
                    scrollable
                    size="xl"
                    centered
                    className="bg-transparent modal"
                >
                    <BsModal.Header
                        closeButton
                        className="p-2"
                    ></BsModal.Header>

                    {/* <iframe src={imgSrc}  width="100%" height="600px"></iframe> */}
                    <object
                        className="vh-100"
                        data={imgSrc}
                        type="application/pdf"
                        onLoad={() => setLoading(false)}
                        onError={() => setError(true)}
                    ></object>
                </BsModal>
            </>
        ) : isOtherFile === true || isSpreadSheet === true? ( //If file type is other than image and pdf
            <BsModal
                show={show}
                onHide={handleClose}
                scrollable
                size="xl"
                centered
                className="bg-modal-transparent modal-no-br modal-shadow modal-no-border"
            >
                <BsModal.Header className="py-2 bg-dark text-white rounded-0">
                    <BsModal.Title className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-center">
                            <button
                                className="btn btn-dark text-white"
                                onClick={handleClose}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="25"
                                    fill="currentColor"
                                    class="bi bi-arrow-left"
                                    viewBox="0 0 16 16"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
                                    />
                                </svg>
                            </button>
                            <p className="fs-18px m-0 ps-2 fw-bold mt-1">
                                File name
                            </p>
                        </div>
                        <div className="d-flex align-items-center">
                            <button
                                className="btn bg-dark p-0 border-0 px-2"
                                onClick={downloadOtherFile}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    id="noun-download-3465422"
                                    width="26"
                                    height="26"
                                    viewBox="4 4 24 24"
                                    fill="currentColor"
                                    className="text-white"
                                >
                                    {' '}
                                    <path
                                        id="Path_53898"
                                        data-name="Path 53898"
                                        d="M254.85,150.991a.5.5,0,0,0,.082.536l3.743,4.226a.515.515,0,0,0,.747,0l3.743-4.226a.5.5,0,0,0-.374-.83h-2.246v-4.509a.5.5,0,0,0-.5-.5h-2a.5.5,0,0,0-.5.5V150.7h-2.246a.5.5,0,0,0-.455.295Z"
                                        transform="translate(-243.549 -137.434)"
                                    />{' '}
                                    <path
                                        id="Path_53899"
                                        data-name="Path 53899"
                                        d="M196,398.258a.749.749,0,0,0,.749.749h12.229a.749.749,0,1,0,0-1.5H196.749A.749.749,0,0,0,196,398.258Z"
                                        transform="translate(-187.362 -377.262)"
                                    />{' '}
                                </svg>
                            </button>
                            <button
                                className="btn btn-close btn-close-white text-white"
                                onClick={handleClose}
                            ></button>
                        </div>
                    </BsModal.Title>
                </BsModal.Header>
                <BsModal.Body className=".theme-scrollbar bg-transparent modal-content-vh-100 blur-5px d-flex align-items-center justify-content-center">
                    <div className="col-12 col-md-9 col-lg-4">
                        <div className="p-3 py-4 rounded-3 bg-dark d-flex flex-column align-items-center justify-content-center">
                            <span>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="45"
                                    height="45"
                                    fill="currentColor"
                                    class="bi bi-exclamation-triangle-fill text-light"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                                </svg>
                            </span>
                            <p className="m-0 fs-15px text-light text-center py-3">
                                Preview is not available for this file format{' '}
                                <br />
                                Please download to view the file.
                            </p>
                            <button
                                className="btn bg-primary-dark text-white fs-15px "
                                onClick={downloadOtherFile}
                            >
                                <span className="mt-1">Download file</span>
                            </button>
                        </div>
                    </div>
                </BsModal.Body>
            </BsModal>
        ) : (
            //Preview the image
            <BsModal
                show={show}
                onHide={handleClose}
                scrollable
                size={modalSize}
                centered
                downloadUrl={downloadUrl}
            >
                <BsModal.Header className="pb-0 justify-content-between">
                    <BsModal.Title>Preview</BsModal.Title>
                    {search.includes('dashboard-detail') ? (
                        <span>
                            <button className="btn">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="currentColor"
                                    class="bi bi-download"
                                    viewBox="0 0 16 16"
                                    onClick={downloadOtherFile}
                                >
                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z" />
                                </svg>
                            </button>
                            <button
                                className="btn btn-close top-0 "
                                onClick={handleClose}
                            ></button>
                        </span>
                    ) : (
                        <>
                            <button
                                className="btn btn-close top-0 "
                                onClick={handleClose}
                            ></button>
                        </>
                    )}
                </BsModal.Header>
                <BsModal.Body className=".overflow-hidden p-0 m-3">
                    <Row className="align-items-center justify-content-center">
                        <Col
                            lg={12}
                            className="position-relative min-h-350px"
                        >
                            <Image
                                alt={`failed to load`}
                                src={imgSrc}
                                className={`w-100 position-absolute`}
                                id="modalImage"
                                onClick={dragImage}
                            />
                        </Col>
                    </Row>
                </BsModal.Body>
                <BsModal.Footer className="d-none d-lg-block px-3">
             
                    {/* <Row className="align-items-center">
                        <Col xs={2} md={2} className="d-flex align-items-center justify-content-center">
                        <button className="btn border-0 p-0 h-35px w-35px d-flex align-items-center justify-content-center rounded-circle bg-hover-grey bg-active-grey" onClick={handleZoomOut} disabled={zoomValue === 0}>
                       
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-zoom-out text-theme"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
                                    />
                                <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                <path
                                    fill-rule="evenodd"
                                    d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5"
                                    />
                            </svg>
                                    </button>
                        </Col>
                        <Col xs={8} md={8} className="d-flex align-items-center h-100">
                            <input
                                type="range"
                                class="form-range shadow-none"
                                min="0"
                                max="5"
                                step="0.5"
                                id="zoomRange"
                                onChange={(e)=> handleZoom(+e.target.value)}
                                defaultValue={0}
                                value={zoomValue}
                            />
                        </Col>
                        <Col xs={2} md={2} className="d-flex align-items-center justify-content-center">

                          <button className="btn border-0 p-0 h-35px w-35px d-flex align-items-center justify-content-center rounded-circle bg-hover-grey bg-active-grey" onClick={handleZoomIn} disabled={zoomValue >= 5}>
                       
                          <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-zoom-in text-theme"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
                                />
                                <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                <path
                                    fill-rule="evenodd"
                                    d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
                                />
                            </svg>
                               </button>
                          
                        </Col>
                    </Row> */}

                    <div className="d-flex align-items-center">
                      <div className="me-3">
                      <button className="btn p-2 bg-theme-grey bg-hover-grey rounded-2 border-0" onClick={rotateImage}>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="text-theme" width="20" height="20" viewBox="0 0 22.448 22.801">
                      <path id="Icon_material-rotate-90-degrees-ccw" data-name="Icon material-rotate-90-degrees-ccw" d="M7.986,6.978l-6.7,6.706L8,20.381l6.706-6.7L7.986,6.978ZM4.214,13.685,8,9.9l3.772,3.782L7.986,17.467ZM20.407,7.216a9.247,9.247,0,0,0-6.572-2.728V1.14L9.453,5.521,13.835,9.9V6.555A7.233,7.233,0,1,1,10.9,20.391l-1.54,1.54A9.292,9.292,0,0,0,20.407,7.216Z" transform="translate(-0.937 -0.537)" stroke="#f6f6f6" stroke-width="0.5"/>
                    </svg>
                          </button>
                      </div>
                      <div className="p-2 bg-theme-grey bg-hover-grey rounded-2 w-100 d-flex ">
                      <button className="btn border-0 bg-hover-grey bg-theme-grey rounded-2 p-0" onClick={handleZoomIn} disabled={zoomValue >= 5}>
                      <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="currentColor"
                                class="bi bi-zoom-in text-theme"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"
                                />
                                <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z" />
                                <path
                                    fill-rule="evenodd"
                                    d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"
                                />
                            </svg>
                      </button>
                      <div className="mx-2 w-100 h-100">
                      <input
                                type="range"
                                class="form-range shadow-none align-middle"
                                min="0"
                                max="5"
                                step="0.5"
                                id="zoomRange"
                                onChange={(e)=> handleZoom(+e.target.value)}
                                defaultValue={0}
                                value={zoomValue}
                            />
                      </div>
                      <div>
                        
                      </div>
                      </div>
                    </div>
                </BsModal.Footer>
            </BsModal>
        )}
    </>
);
};

Modal.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  imgSrc: PropTypes.string.isRequired,
  isPdf: PropTypes.bool.isRequired,
};

export default Modal;
